import {CCard, CCardBody, CCardHeader} from "@coreui/react";
import {SortableContext, verticalListSortingStrategy} from "@dnd-kit/sortable";
import React from "react";
import SortableTaskCard from "./OrdenableTareaCarta";

const Column = ({ column, tasks, onOpenTask, onDeleteTask, onViewTask, employeesById }) => {
    return (
        <CCard className="border-0 shadow-sm h-100">
            <CCardHeader className="fw-semibold bg-white">{column.name}</CCardHeader>
            <CCardBody className="bg-light" style={{ minHeight: 300 }}>
                <SortableContext items={tasks.map((t) => t.id)} strategy={verticalListSortingStrategy}>
                    <div className="d-flex flex-column gap-2">
                        {tasks.map((t) => (
                            <SortableTaskCard
                                key={t.id}
                                task={t}
                                employeesById={employeesById}
                                onOpen={() => onOpenTask(t)}
                                onDelete={() => onDeleteTask(t.id)}
                                onView={() => onViewTask(t)}
                            />
                        ))}
                        {tasks.length === 0 && <div className="text-center text-muted py-4 small">Suelta tareas aquí</div>}
                    </div>
                </SortableContext>
            </CCardBody>
        </CCard>
    )
}

export default Column;